import { useEffect, useMemo, useState } from 'react';

/**
 * Reads a manifest from `public/media/{scope}/manifest.json`.
 * scope: 'owner' | 'customer'
 */
export default function useMediaManifest(scope) {
  const basePath = scope ? `/media/${scope}` : '/media';
  const manifestPath = scope ? `${basePath}/manifest.json` : '/media/manifest.json';

  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    fetch(manifestPath, { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : { items: [] }))
      .then((data) => {
        if (!alive) return;
        setItems(Array.isArray(data.items) ? data.items : []);
      })
      .catch(() => {
        if (!alive) return;
        setItems([]);
      });

    return () => {
      alive = false;
    };
  }, [manifestPath]);

  const safeItems = useMemo(() => {
    return items
      .filter((x) => x && typeof x.src === 'string')
      .map((x) => ({
        src: x.src.startsWith('/') ? x.src : `${basePath}/${x.src}`,
        type: x.type || 'image',
        alt: x.alt || 'Gallery item'
      }));
  }, [items, basePath]);

  return safeItems;
}
